<!--  CONFIRM MESSAGE  -->

<div class="written-content padded">
	<p *ngFor="let sentence of config.content">{{sentence}}</p>
</div>

<!--  END CONFIRM MESSAGE  -->
